import dynamic from "next/dynamic";
import { ReactNode, cloneElement } from "react";

const AppLayout = dynamic(() => import("./AppLayout"), { ssr: true });
const PreviewLayout = dynamic(() => import("./PreviewLayout"), { ssr: false });

interface LayoutProps {
    layoutType: keyof typeof Layouts;
    layoutProps: object;
    children?: ReactNode;
}

const Layouts = {
    Main: <AppLayout />,
    Preview: <PreviewLayout />
};

export const Layout: React.FC<LayoutProps> = ({ layoutType, layoutProps, children }) => {
    const LayoutComponent = Layouts[layoutType];

    if (!LayoutComponent) {
        console.error(`Layout type "${layoutType}" is not defined.`);
        return null; // or return a fallback layout
    }

    return cloneElement(LayoutComponent, { layoutProps, children });
};

export type LayoutKeys = keyof typeof Layouts; // "Main" | "Preview"
